import { useCallback } from "react";

import { Button } from "@transfr-inc/dashboard-components/forms";

import { useExternalLink } from "@features/ui";
import { useAuth } from "@hooks/use-auth";
import { buttonTracking } from "@lib/tracking.helpers";
import { FEEDBACK_FORM_URL } from "@src/constants";

import "./feedback.button.scss";

export const FeedbackButton = () => {
  const { user } = useAuth();
  // Transfr's own feedback form, not a way to reach the outside world.
  const { open } = useExternalLink({ allowInSecureMode: true });

  const onFeedbackClick = useCallback(() => {
    const link = FEEDBACK_FORM_URL.getUrl({
      orgCode: user.orgCode,
      email: user.email,
    });

    open(link, { label: "Feedback" });
  }, [open, user]);

  return (
    <div className="feedback-button">
      <Button
        icon={["fasr", "arrow-up-right-from-square"]}
        onClick={onFeedbackClick}
        {...buttonTracking("feedback")}
      >
        Feedback
      </Button>
    </div>
  );
};
